import { styled } from '@/shared/styles/theme'

export const BaseBox = styled('div', {
  backgroundColor: '$white',
  borderRadius: '$sm',
  border: 'transparent',
})
